module.exports = __webpack_public_path__ + "img/TS6202-311.e2af983b.jpg";